import { resetPassword } from "api/services/auth";
import { useMutation } from "react-query";
import { EAuthQueryKeys } from "api/endpoints/auth";
import { logError } from "utils/notifications";
import { TResetPasswordBody } from "types/api/auth";
import { TApiError } from "types/api/error";

export const useResetPassword = () => {
  return useMutation<void, TApiError, TResetPasswordBody>(
    EAuthQueryKeys.resetPassword,
    resetPassword,
    {
      onError: (error) => {
        logError({ error });
      },
      retry: false,
    }
  );
};
